import React from 'react';
import Container from 'container';
import Headline from 'headline';
import Button from 'button';
import Icon from 'icon';
import s from './page-404.module.scss';

export default function ErrorComponent() {
  return (
    <Container className={s.root} image="above-aerial-dark">
      <div className={s.wrapper}>
        <Icon className={s.icon} icon="404" />
        <Headline className={s.title} h1 center white html="Whoops!" />
        <div className={s.underline} />
        <p className={s.text}>Looks like you've lost your way</p>
        <div className={s.buttonWrapper}>
          <Button className={s.button} primary href="/">
            <Icon className={s.arrow} icon="small-arrow-left" />
            Back to Homepage
          </Button>
        </div>
      </div>
    </Container>
  );
}
